import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DeviceOrderingService } from 'src/app/services/device-ordering/device-ordering.service';
import { OrderRequestApprovedState, OrderRequestVO } from 'src/app/services/device-ordering/value-objects/order.vo';
import { SnackService } from 'src/app/services/snack.service';
import { RejectOrderRequestValidator } from 'src/app/shared/validators/order-request.validators';
@Component({
  selector: 'app-reject-order-dialog',
  templateUrl: './reject-order-dialog.component.html',
  styleUrls: ['./reject-order-dialog.component.scss'],
})
export class RejectOrderDialogComponent implements OnInit, OnDestroy {
  rejectForm: UntypedFormGroup;
  showProgressBar = false;
  rejectOptions: string[] = [];
  unsubscribe$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrderRequestVO,
    private dialogRef: MatDialogRef<RejectOrderDialogComponent>,
    private fb: UntypedFormBuilder,
    private deviceOrderService: DeviceOrderingService,
    private snackService: SnackService
  ) {}

  ngOnInit(): void {
    this.rejectForm = this.fb.group(
      {
        reason: [''],
        otherReason: [''],
      },
      { validators: [RejectOrderRequestValidator] }
    );
    this.loadRejectOptions();
  }

  loadRejectOptions(): void {
    this.deviceOrderService
      .getOptionsRejectOrder()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((options) => {
        this.rejectOptions = options;
      });
  }

  reject(): void {
    if (this.rejectForm.invalid) {
      return;
    }

    this.showProgressBar = true;
    const orderRequest = { ...this.data };
    orderRequest.approved = OrderRequestApprovedState.FALSE;
    orderRequest.comments =
      this.rejectForm.get('reason').value === 'Other'
        ? this.rejectForm.get('otherReason').value
        : this.rejectForm.get('reason').value;
    this.deviceOrderService
      .updateOrderRequest(orderRequest)
      .then((resp) => {
        this.deviceOrderService.sendNotificationRejectOrder(orderRequest).subscribe({
          next: () => this.snackService.genericSnackBar('Device Order Rejected', ['success-snackbar'], 5000),
          error: (err) => console.error('Failed to send rejected order email', err),
        });
        this.dialogRef.close(true);
      })
      .catch((error) => {
        this.showProgressBar = false;
        this.snackService.genericSnackBar('Error rejecting order', ['error-snackbar'], 5000);
        console.error('Error rejecting order:', error);
      });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
